export class RestoreDbToRdsInstanceRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "DatabaseDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDbToRdsInstanceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
